import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "px-10 py-8 justify-self-start self-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "block text-2xl text-gray-700" }, "Plan Yükseltme Talebi Oluştur", -1)
const _hoisted_7 = { class: "block text-xl text-gray-700 mb-4" }
const _hoisted_8 = { class: "pt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "descOne",
  class: "block text-sm font-medium text-gray-700"
}, "Talep açıklaması", -1)
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = {
  key: 0,
  class: "pt-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "newValue",
  class: "block text-sm font-medium text-gray-700"
}, "Yeni değer", -1)
const _hoisted_13 = { class: "mt-1 w-20" }
const _hoisted_14 = {
  key: 1,
  class: "pt-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "newValue",
  class: "block text-sm font-medium text-gray-700"
}, "Yeni plan", -1)
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "pt-2 mt-10" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_22 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "px-10 py-8 justify-self-start self-start" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "block text-2xl text-gray-700 mb-4" }, "Yükseltme Talebi Onay/Red", -1)
const _hoisted_26 = { class: "pt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "descOne",
  class: "block text-sm font-medium text-gray-700"
}, "Onay/Red notu", -1)
const _hoisted_28 = { class: "mt-1" }
const _hoisted_29 = { class: "pt-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "okjlk",
  class: "block text-sm font-medium text-gray-700"
}, "Şifre", -1)
const _hoisted_31 = { class: "mt-1" }
const _hoisted_32 = { class: "pt-2 space-x-2 mt-10" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = { class: "grid grid-cols-7 gap-6 mb-6 bg-gray-50 py-4 px-4 border border-gray-200 max-w-5xl mx-auto mt-2" }
const _hoisted_37 = { class: "col-span-7 sm:col-span-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "xyz1",
  class: "block text-sm font-medium text-gray-700"
}, "Organizasyon", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-400 mt-1" }, "Organizasyonun adından 'içinde geçen' şeklinde arama yapılır", -1)
const _hoisted_40 = { class: "col-span-7 sm:col-span-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "osman1",
  class: "block text-sm font-medium text-gray-700"
}, "e-Posta", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-400 mt-1" }, "Birden çok e-posta adresi aralarında boşluk bırakılarak girilebilir ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-400 mt-1" }, "Tek bir e-posta adresi aranacaksa 'içinde geçen' şeklinde arama yapılır", -1)
const _hoisted_44 = { class: "col-span-7 sm:col-span-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "mehmet2",
  class: "block text-sm font-medium text-gray-700"
}, "Plan", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-400 mt-1" }, "Plan adından 'içinde geçen' şeklinde arama yapılır", -1)
const _hoisted_47 = { class: "col-span-7 sm:col-span-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-transparent" }, ".", -1)
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "" }, "Ara", -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_53 = { class: "align-middle inline-block min-w-full" }
const _hoisted_54 = { class: "shadow overflow-hidden border-b border-cyan-200" }
const _hoisted_55 = { class: "min-w-full divide-y divide-cyan-200" }
const _hoisted_56 = { class: "bg-cyan-400" }
const _hoisted_57 = {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider flex items-center space-x-2"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", null, "Id", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}, " Organization Name", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}, " Owner User", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}, " Plan", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}, " Created Date", -1)
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 flex items-center space-x-2" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_67 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_68 = { class: "font-medium" }
const _hoisted_69 = { class: "-mt-1 text-xs opacity-70" }
const _hoisted_70 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_71 = { class: "font-medium" }
const _hoisted_72 = { class: "-mt-1 text-xs opacity-70" }
const _hoisted_73 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_74 = {
  colspan: "5",
  class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500"
}
const _hoisted_75 = { class: "overflow-hidden mx-auto" }
const _hoisted_76 = { class: "divide-y divide-amber-200 text-xs border border-amber-200 sm:rounded-lg mx-auto" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-amber-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Id"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Plan"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Dates"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " Free/Total License"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " Eyp1"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " KEP"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " SFTP"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " External Users"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " Advanced Flow"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " UIM"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " SignHub API"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider"
    }, " coreAPI")
  ])
], -1)
const _hoisted_78 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_79 = { class: "px-6 py-4 whitespace-nowrap text-gray-500" }
const _hoisted_80 = { class: "flex items-center space-x-1" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "-mt-1 text-xs opacity-70 no-underline" }
const _hoisted_83 = { class: "px-6 py-4 whitespace-nowrap text-gray-500" }
const _hoisted_84 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 flex justify-center" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_99 = ["onClick"]
const _hoisted_100 = { class: "px-6 py-4 whitespace-nowrap text-gray-500 text-center" }
const _hoisted_101 = ["onClick"]
const _hoisted_102 = {
  colspan: "12",
  class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500"
}
const _hoisted_103 = { class: "overflow-hidden mx-auto" }
const _hoisted_104 = { class: "divide-y divide-lime-200 text-xs border border-lime-200 sm:rounded-lg mx-auto" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-lime-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Id"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Upgrade Id"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Upgrade Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " New Value"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Creator User"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Creator Note"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Approved Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Approver"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Approver Note"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
    }, " Created Date")
  ])
], -1)
const _hoisted_106 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_107 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_108 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_111 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_112 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_113 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_114 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_115 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_116 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_117 = { class: "px-6 py-4 whitespace-nowrap font-medium text-gray-900" }
const _hoisted_118 = { class: "grid grid-cols-3 mx-auto space-x-4 my-10" }
const _hoisted_119 = { class: "bg-white shadow overflow-hidden sm:rounded-lg max-w-5xl border" }
const _hoisted_120 = { class: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6" }
const _hoisted_121 = { class: "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "ml-4 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "Editörle e-Posta Gönder")
], -1)
const _hoisted_123 = { class: "ml-4 mt-2 flex-shrink-0" }
const _hoisted_124 = ["disabled"]
const _hoisted_125 = { class: "p-8" }
const _hoisted_126 = { class: "grid gap-6" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", {
  for: "target-subject",
  class: "block text-sm font-medium text-gray-700"
}, "e-Posta Konusu", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", {
  for: "target-mail-addresses",
  class: "block text-sm font-medium text-gray-700"
}, "e-Posta Adresleri", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-xs text-gray-500 whitespace-normal" }, "Bu alan girilirse, seçilen organizasyon yerine burada yazılan e-posta adreslerine gönderim yapılır.", -1)
const _hoisted_130 = { class: "pb-20" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "e-Posta İçeriği", -1)
const _hoisted_132 = { key: 0 }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", {
  for: "about",
  class: "block text-sm font-medium text-gray-700"
}, " e-Posta gönderilen adresler ", -1)
const _hoisted_134 = { class: "mt-1" }
const _hoisted_135 = { class: "shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md" }
const _hoisted_136 = { class: "p-4 justify-self-start self-start" }
const _hoisted_137 = { class: "bg-white shadow overflow-hidden sm:rounded-lg max-w-5xl border" }
const _hoisted_138 = { class: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6" }
const _hoisted_139 = { class: "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "ml-4 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "HTML Olarak e-Posta Gönder")
], -1)
const _hoisted_141 = { class: "ml-4 mt-2 flex-shrink-0" }
const _hoisted_142 = ["disabled"]
const _hoisted_143 = { class: "p-8" }
const _hoisted_144 = { class: "grid gap-6" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", {
  for: "target-subject",
  class: "block text-sm font-medium text-gray-700"
}, "e-Posta Konusu", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("label", {
  for: "target-mail-addresses-html",
  class: "block text-sm font-medium text-gray-700"
}, "e-Posta Adresleri", -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-xs text-gray-500 whitespace-normal" }, "Bu alan girilirse, seçilen organizasyon yerine burada yazılan e-posta adreslerine gönderim yapılır.", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", {
  for: "about",
  class: "block text-sm font-medium text-gray-700"
}, " e-Posta İçeriği ", -1)
const _hoisted_149 = { class: "mt-1" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-gray-500" }, "Buraya e-posta içeriği HTML olarak girilir.", -1)
const _hoisted_151 = { key: 0 }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("label", {
  for: "about",
  class: "block text-sm font-medium text-gray-700"
}, " e-Posta gönderilen adresler ", -1)
const _hoisted_153 = { class: "mt-1" }
const _hoisted_154 = { class: "shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md" }
const _hoisted_155 = { class: "p-4 justify-self-start self-start" }
const _hoisted_156 = { class: "bg-white shadow overflow-hidden sm:rounded-lg max-w-5xl border" }
const _hoisted_157 = { class: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6" }
const _hoisted_158 = { class: "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "ml-4 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "Sistem Ayarları")
], -1)
const _hoisted_160 = { class: "ml-4 mt-2 flex-shrink-0" }
const _hoisted_161 = ["disabled"]
const _hoisted_162 = {
  key: 0,
  class: "p-8"
}
const _hoisted_163 = { class: "grid gap-6" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("label", {
  for: "about",
  class: "block text-sm font-medium text-gray-700"
}, " Sistem ayarları ", -1)
const _hoisted_165 = { class: "mt-1" }
const _hoisted_166 = { class: "shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md" }
const _hoisted_167 = { class: "p-4 justify-self-start self-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.createSubscriptionUpgradeRequest != null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "template",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createSubscriptionUpgradeRequest = null))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.createSubscriptionUpgradeRequest)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.getSubscriptionUpgradeUpgradeType(_ctx.createSubscriptionUpgradeRequest.upgradeType)), 1),
                            _createElementVNode("div", _hoisted_8, [
                              _hoisted_9,
                              _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.createSubscriptionUpgradeRequest.creatorNote) = $event)),
                                  id: "descOne",
                                  name: "descOne",
                                  rows: "3",
                                  class: "outline-none focus:outline-none p-2 shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                                }, null, 512), [
                                  [_vModelText, _ctx.createSubscriptionUpgradeRequest.creatorNote]
                                ])
                              ])
                            ]),
                            (_ctx.createSubscriptionUpgradeRequest.upgradeType !== _ctx.SubscriptionUpgradeUpgradeTypeEnum.UpgradeToNewPlan)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _hoisted_12,
                                  _createElementVNode("div", _hoisted_13, [
                                    _withDirectives(_createElementVNode("input", {
                                      id: "newValue",
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createSubscriptionUpgradeRequest.newValue) = $event)),
                                      name: "newValue",
                                      autocomplete: "off",
                                      class: "outline-none focus:outline-none p-2 shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                                    }, null, 512), [
                                      [_vModelText, _ctx.createSubscriptionUpgradeRequest.newValue]
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createElementVNode("div", _hoisted_16, [
                                    _withDirectives(_createElementVNode("select", {
                                      id: "selected-tab",
                                      name: "selected-tab",
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createSubscriptionUpgradeRequest.newValue) = $event)),
                                      class: "shadow-sm focus:ring-sky-500 focus:border-sky-500 block w-full sm:text-sm border px-2 py-2 border-gray-300 rounded-md"
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: plan.name,
                                          value: plan.name
                                        }, _toDisplayString(plan.displayNameForWeb + " - " + plan.name), 9, _hoisted_17))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _ctx.createSubscriptionUpgradeRequest.newValue]
                                    ])
                                  ])
                                ])),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.planUpgrade())),
                                type: "button",
                                disabled: _ctx.isWorking,
                                class: "inline-flex items-center justify-center px-4 py-1 text-sm border border-transparent font-medium rounded-md shadow-sm text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:text-gray-200 disabled:bg-gray-400"
                              }, " Talep Oluştur ", 8, _hoisted_19)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.approveOrDenySubscriptionUpgradeRequest != null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "template",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.approveOrDenySubscriptionUpgradeRequest = null))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_21,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.approveOrDenySubscriptionUpgradeRequest)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("div", null, "Talep Kodu: " + _toDisplayString(_ctx.approveOrDenySubscriptionUpgradeRequest.planUpgradeRequestId), 1),
                            _createElementVNode("div", null, "Organizasyon Id: " + _toDisplayString(_ctx.approveOrDenySubscriptionUpgradeRequest.organizationId), 1),
                            _createElementVNode("div", null, "Üyelik Id: " + _toDisplayString(_ctx.approveOrDenySubscriptionUpgradeRequest.subscriptionId), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("div", _hoisted_28, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.approveOrDenySubscriptionUpgradeRequest.approverNote) = $event)),
                                  id: "descOne",
                                  name: "descOne",
                                  rows: "3",
                                  class: "outline-none focus:outline-none p-2 shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                                }, null, 512), [
                                  [_vModelText, _ctx.approveOrDenySubscriptionUpgradeRequest.approverNote]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("div", _hoisted_31, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.approveOrDenySubscriptionUpgradeRequest.passwordForOperation) = $event)),
                                  autocomplete: "off",
                                  id: "okjlk",
                                  name: "okjlk",
                                  class: "outline-none focus:outline-none p-2 shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                                }, null, 512), [
                                  [_vModelText, _ctx.approveOrDenySubscriptionUpgradeRequest.passwordForOperation]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("button", {
                                type: "button",
                                disabled: _ctx.isWorking,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.ApproveOrDenySubscriptionUpgrade(true))),
                                class: "inline-flex items-center justify-center px-4 py-1 text-sm border border-transparent font-medium rounded-md shadow-sm text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:text-gray-200 disabled:bg-gray-400"
                              }, " Yükseltmeyi Onayla ", 8, _hoisted_33),
                              _createElementVNode("button", {
                                type: "button",
                                disabled: _ctx.isWorking,
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ApproveOrDenySubscriptionUpgrade(false))),
                                class: "inline-flex items-center justify-center px-4 py-1 text-sm border border-transparent font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:text-gray-200 disabled:bg-gray-400"
                              }, " Reddet ", 8, _hoisted_34)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.organizationFilter) = $event)),
            type: "text",
            name: "xyz1",
            id: "xyz1",
            autocomplete: "off",
            class: "mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          }, null, 512), [
            [_vModelText, _ctx.organizationFilter]
          ]),
          _hoisted_39
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.eMailFilter) = $event)),
            type: "text",
            name: "osman1",
            id: "osman1",
            autocomplete: "off",
            class: "mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          }, null, 512), [
            [_vModelText, _ctx.eMailFilter]
          ]),
          _hoisted_42,
          _hoisted_43
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.planFilter) = $event)),
            type: "text",
            name: "mehmet2",
            id: "mehmet2",
            autocomplete: "off",
            class: "mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          }, null, 512), [
            [_vModelText, _ctx.planFilter]
          ]),
          _hoisted_46
        ]),
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("button", {
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.getOrganizations && _ctx.getOrganizations(...args))),
            disabled: _ctx.isWorking,
            class: "mt-1 w-full flex justify-center py-2 px-4 border border-transparent rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 text-white bg-sky-600 disabled:bg-gray-600 hover:bg-sky-700 focus:ring-sky-500 shadow-sm"
          }, _hoisted_51, 8, _hoisted_49)
        ])
      ]),
      (_ctx.organizations)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("table", _hoisted_55, [
                  _createElementVNode("thead", _hoisted_56, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-4 h-4 border", [_ctx.isAllSelected ? 'bg-green-600 border-gray-200' : ' bg-white border-gray-500']]),
                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.selectAll()), ["stop"]))
                        }, null, 2)
                      ]),
                      _hoisted_59,
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizations, (organization, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: organization.id
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass(["cursor-pointer", index % 2 === 0 ? 'bg-cyan-50' : 'bg-cyan-100']),
                          onClick: ($event: any) => (organization.isExpanded = !organization.isExpanded)
                        }, [
                          _createElementVNode("td", _hoisted_64, [
                            _createElementVNode("div", null, _toDisplayString(organization.id), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-4 h-4 border", [organization.isSelected ? 'bg-green-600 border-gray-200' : ' bg-white border-gray-500']]),
                              onClick: _withModifiers(($event: any) => (organization.isSelected = !organization.isSelected), ["stop"])
                            }, null, 10, _hoisted_65)
                          ]),
                          _createElementVNode("td", _hoisted_66, _toDisplayString(organization.displayName), 1),
                          _createElementVNode("td", _hoisted_67, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_68, _toDisplayString(organization.ownerUserEMail), 1),
                              _createElementVNode("div", _hoisted_69, _toDisplayString(organization.ownerUserDisplayName), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_70, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.getPlanName(organization.plan)), 1),
                              _createElementVNode("div", _hoisted_72, _toDisplayString(organization.plan), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.formatDateLong(organization.createdDate)), 1)
                        ], 10, _hoisted_63),
                        (organization.isExpanded)
                          ? (_openBlock(), _createElementBlock("tr", {
                              key: 0,
                              class: _normalizeClass(index % 2 === 0 ? 'bg-cyan-50' : 'bg-cyan-100')
                            }, [
                              _createElementVNode("td", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("table", _hoisted_76, [
                                    _hoisted_77,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.subscriptions, (subscription, index1) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: subscription.id
                                        }, [
                                          _createElementVNode("tr", {
                                            class: _normalizeClass(index1 % 2 === 0 ? 'bg-amber-50' : 'bg-amber-100')
                                          }, [
                                            _createElementVNode("td", _hoisted_78, _toDisplayString(subscription.id), 1),
                                            _createElementVNode("td", _hoisted_79, [
                                              _createElementVNode("div", _hoisted_80, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass([[subscription.isActive ? 'bg-green-500' : 'bg-red-500'], "h-2 w-2 rounded-full opacity-50"])
                                                }, null, 2),
                                                _createElementVNode("div", {
                                                  onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.UpgradeToNewPlan, subscription.isActive))
                                                }, [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["font-medium", [subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : '']])
                                                    }, _toDisplayString(_ctx.getPlanName(subscription.planName)), 3),
                                                    _createElementVNode("div", _hoisted_82, _toDisplayString(subscription.planName), 1)
                                                  ])
                                                ], 8, _hoisted_81)
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_83, [
                                              _createElementVNode("div", null, _toDisplayString(_ctx.formatDateLong(subscription.startDate)), 1),
                                              _createElementVNode("div", null, _toDisplayString(_ctx.formatDateLong(subscription.endDate)), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_84, [
                                              _createTextVNode(_toDisplayString(subscription.freeLicenseCount) + " / ", 1),
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.TotalLicenseCount, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.totalLicenseCount), 11, _hoisted_85)
                                            ]),
                                            _createElementVNode("td", _hoisted_86, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.CanCreateEyp1, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.canCreateEyp1), 11, _hoisted_87)
                                            ]),
                                            _createElementVNode("td", _hoisted_88, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.CanSendKEP, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.canSendKEP), 11, _hoisted_89)
                                            ]),
                                            _createElementVNode("td", _hoisted_90, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.CanSendSFTP, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.canSendSFTP), 11, _hoisted_91)
                                            ]),
                                            _createElementVNode("td", _hoisted_92, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.CanSendToExternalUsers, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.canSendToExternalUsers), 11, _hoisted_93)
                                            ]),
                                            _createElementVNode("td", _hoisted_94, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.CanUseAdvancedFlow, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.canUseAdvancedFlow), 11, _hoisted_95)
                                            ]),
                                            _createElementVNode("td", _hoisted_96, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.CanUseUim, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.canUseUim), 11, _hoisted_97)
                                            ]),
                                            _createElementVNode("td", _hoisted_98, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.TotalApiLicenseCount, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.totalApiLicenseCount), 11, _hoisted_99)
                                            ]),
                                            _createElementVNode("td", _hoisted_100, [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (_ctx.openModalForCreateRequest(organization.id, subscription.id, _ctx.SubscriptionUpgradeUpgradeTypeEnum.TotalCoreApiLicenseCount, subscription.isActive)),
                                                class: _normalizeClass([subscription.isActive ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                              }, _toDisplayString(subscription.totalCoreApiLicenseCount), 11, _hoisted_101)
                                            ])
                                          ], 2),
                                          (subscription.subscriptionUpgrades && subscription.subscriptionUpgrades.length > 0)
                                            ? (_openBlock(), _createElementBlock("tr", {
                                                key: 0,
                                                class: _normalizeClass(index1 % 2 === 0 ? 'bg-amber-50' : 'bg-amber-100')
                                              }, [
                                                _createElementVNode("td", _hoisted_102, [
                                                  _createElementVNode("div", _hoisted_103, [
                                                    _createElementVNode("table", _hoisted_104, [
                                                      _hoisted_105,
                                                      _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscription.subscriptionUpgrades, (subscriptionUpgrade, index1) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: subscriptionUpgrade.id,
                                                            class: _normalizeClass(index1 % 2 === 0 ? 'bg-lime-50' : 'bg-lime-100')
                                                          }, [
                                                            _createElementVNode("td", _hoisted_106, _toDisplayString(subscriptionUpgrade.id), 1),
                                                            _createElementVNode("td", _hoisted_107, _toDisplayString(subscriptionUpgrade.upgradeId), 1),
                                                            _createElementVNode("td", _hoisted_108, [
                                                              _createElementVNode("div", {
                                                                onClick: ($event: any) => (_ctx.openApproveOrDenyModal(subscriptionUpgrade, organization.id, subscription.id, subscription.isActive)),
                                                                class: _normalizeClass([subscription.isActive && subscriptionUpgrade.status == _ctx.SubscriptionUpgradeStatusEnum.Created ? 'cursor-pointer text-sky-500 font-medium underline' : ''])
                                                              }, _toDisplayString(subscriptionUpgrade.statusString), 11, _hoisted_109)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_110, _toDisplayString(subscriptionUpgrade.upgradeTypeString), 1),
                                                            _createElementVNode("td", _hoisted_111, _toDisplayString(subscriptionUpgrade.newValue), 1),
                                                            _createElementVNode("td", _hoisted_112, _toDisplayString(subscriptionUpgrade.creatorUserEMail), 1),
                                                            _createElementVNode("td", _hoisted_113, _toDisplayString(subscriptionUpgrade.creatorNote), 1),
                                                            _createElementVNode("td", _hoisted_114, _toDisplayString(_ctx.formatDateLong(subscriptionUpgrade.approvedDate)), 1),
                                                            _createElementVNode("td", _hoisted_115, _toDisplayString(subscriptionUpgrade.approverUserEMail), 1),
                                                            _createElementVNode("td", _hoisted_116, _toDisplayString(subscriptionUpgrade.approverNote), 1),
                                                            _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.formatDateLong(subscriptionUpgrade.createdDate)), 1)
                                                          ], 2))
                                                        }), 128))
                                                      ])
                                                    ])
                                                  ])
                                                ])
                                              ], 2))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_118, [
        _createElementVNode("div", _hoisted_119, [
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _hoisted_122,
              _createElementVNode("div", _hoisted_123, [
                _createElementVNode("button", {
                  disabled: _ctx.isWorking,
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sendEMail(_ctx.mailSubjectQuill, _ctx.mailBodyQuill, 'quill'))),
                  type: "button",
                  class: "relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                }, " Gönder ", 8, _hoisted_124)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_125, [
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("div", null, [
                _hoisted_127,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.mailSubjectQuill) = $event)),
                  type: "text",
                  name: "target-subject",
                  id: "target-subject",
                  autocomplete: "email",
                  class: "mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                }, null, 512), [
                  [_vModelText, _ctx.mailSubjectQuill]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_128,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mailtTargetsQuill) = $event)),
                  type: "text",
                  name: "target-mail-addresses",
                  id: "target-subject",
                  autocomplete: "email",
                  class: "mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                }, null, 512), [
                  [_vModelText, _ctx.mailtTargetsQuill]
                ]),
                _hoisted_129
              ]),
              _createElementVNode("div", _hoisted_130, [
                _hoisted_131,
                _createVNode(_component_QuillEditor, {
                  ref: "quillEditor",
                  content: _ctx.mailBodyQuill,
                  "onUpdate:content": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mailBodyQuill) = $event)),
                  theme: "snow",
                  contentType: "html",
                  toolbar: "essential"
                }, null, 8, ["content"])
              ]),
              (_ctx.resultQuill)
                ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                    _hoisted_133,
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_136, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultQuill, (setting, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(setting), 1))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_137, [
          _createElementVNode("div", _hoisted_138, [
            _createElementVNode("div", _hoisted_139, [
              _hoisted_140,
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("button", {
                  disabled: _ctx.isWorking,
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendEMail(_ctx.mailSubjectHtml, _ctx.mailBodyHtml, 'html'))),
                  type: "button",
                  class: "relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                }, " Gönder ", 8, _hoisted_142)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("div", null, [
                _hoisted_145,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.mailSubjectHtml) = $event)),
                  type: "text",
                  name: "target-subject",
                  id: "target-subject",
                  autocomplete: "email",
                  class: "mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                }, null, 512), [
                  [_vModelText, _ctx.mailSubjectHtml]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_146,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mailTargetsHtml) = $event)),
                  type: "text",
                  name: "target-mail-addresses-html",
                  id: "target-subject",
                  autocomplete: "email",
                  class: "mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                }, null, 512), [
                  [_vModelText, _ctx.mailTargetsHtml]
                ]),
                _hoisted_147
              ]),
              _createElementVNode("div", null, [
                _hoisted_148,
                _createElementVNode("div", _hoisted_149, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.mailBodyHtml) = $event)),
                    id: "about",
                    name: "about",
                    rows: "10",
                    class: "shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                  }, null, 512), [
                    [_vModelText, _ctx.mailBodyHtml]
                  ])
                ]),
                _hoisted_150
              ]),
              (_ctx.resultHtml)
                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    _hoisted_152,
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_155, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultHtml, (setting, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(setting), 1))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_156, [
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("div", _hoisted_158, [
              _hoisted_159,
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("button", {
                  disabled: _ctx.isWorking,
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.getAllSettings && _ctx.getAllSettings(...args))),
                  type: "button",
                  class: "relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                }, " Sistem Ayarlarını Gör ", 8, _hoisted_161)
              ])
            ])
          ]),
          (_ctx.allSettings)
            ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                _createElementVNode("div", _hoisted_163, [
                  _createElementVNode("div", null, [
                    _hoisted_164,
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_167, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSettings, (setting, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(setting), 1))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}